export const FETCH_SUMMARY = "FETCH_SUMMARY";
export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_TODOS = "FETCH_TODOS";
export const FETCH_MATCHES = "FETCH_MATCHES";
export const UPDATE_MATCH = "UPDATE_MATCH";
